import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Asset, AssetPhoto} from '../../shared/domain/item';
import {ItemSummaryItemSummaryService} from '../../shared/asset/item-summary-item-summary.service';
import {GalleryPhoto, PhotoGalleryUtils} from '../../shared/photo-gallery';
import {ItemViewType} from '../../shared/item-view-type.enum';
import {appConfig} from "../../shared/app.config";

@Component({
  selector: 'lib-item-summary-asset-summary-photo',
  templateUrl: './asset-summary-photo.component.html',
  styleUrls: ['./asset-summary-photo.component.scss']
})
export class AssetSummaryPhotoComponent implements OnInit, OnDestroy {
  @Input() itemId: number;
  @Input() asset: Asset;
  @Input() fromView: ItemViewType;
  @Input() itemSummaryService: ItemSummaryItemSummaryService;
  assetPhoto: AssetPhoto;
  mainPhoto: string;
  photoCount: number;
  private assetPhotoSubscription: Subscription;

  constructor() {
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy(): void {
    if (this.assetPhotoSubscription) {
      this.assetPhotoSubscription.unsubscribe();
    }
  }

  init() {
    setTimeout(() => {
      this.assetPhotoSubscription = this.itemSummaryService.getItemPhotos(this.itemId)
        .subscribe( assetPhoto => {
          this.assetPhoto = assetPhoto;
          this.mainPhoto = this.assetPhoto.media && this.assetPhoto.media.photos && this.assetPhoto.media.photos.length > 0
            ? this.assetPhoto.media.photos[0].highResImageUrl : AssetPhoto.constructBrochurePhotoUrl(this.assetPhoto.brochurePhoto, this.assetPhoto.saleType);
          if (this.assetPhoto.media  && this.assetPhoto.media.photos) {
            this.photoCount = this.assetPhoto.media.photos.length;
          }
        });
    });
  }

  navigateToPhotos() {
    if (this.assetPhoto && this.assetPhoto.assetAlreadyEquip) {
      this.showBeautyShots(0);
    } else {
      if (this.fromView === ItemViewType.AssetPortal) {
        if (this.asset.assetControlGroupId > 0) {
          window.location.href =appConfig.assetManagementPortalRoot+ `/opportunity/asset-packages/${this.asset.assetControlGroupId}/assets/${this.itemId}/inspection/media`;
        }
      }
    }
  }


  showBeautyShots(index) {
    if (this.assetPhoto.media) {
      this.mainPhoto = this.assetPhoto.media.photos[index].highResImageUrl;
      const photo = this.constructMediaBeautyShots(this.assetPhoto.media.photos);
      PhotoGalleryUtils.showPhotoGallery(photo, index);
    }
  }

  constructMediaBeautyShots(photos: any[]): GalleryPhoto[] {
    const imageList = [];
    photos.forEach( photourl => {
      imageList.push({
        typeName: photourl.description,
        imageUrls: {
          small: photourl.lowResImageUrl,
          big: photourl.highResImageUrl
        }
      });
    });
    return imageList;

  }

}
